<template>
  <div class="content-wrapper">
    <app-page-top-section :title="$t('all_packages')" icon="briefcase">
      <app-default-button btn-class="btn btn-success mr-2"
                          :title="$fieldTitle('add', 'package', true)"
                          @click="openModal()"
                          v-if="$can('add_package')"
      />
    </app-page-top-section>

    <app-table
        id="package-management-table"
        :options="options"
        :card-view="false"
        @getRows="getSelectedRows"
        @action="triggerActions"
    />

    <div class="my-4 border-bottom w-100"></div>

    <div class="row">
      <div class="col-lg-12">
        <div class="pricing-table-tab text-center">
          <ul class="nav nav-tabs" id="myTabPricing" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                  class="nav-link"
                  :class="{ active: activeTab === 'monthly' }"
                  id="monthly-tab" data-bs-toggle="tab"
                  data-bs-target="#monthly" role="tab" aria-controls="monthly"
                  @click="setActiveTab('monthly')"
                  aria-selected="true">Monthly
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                  class="nav-link"
                  :class="{ active: activeTab === 'yearly' }"
                  id="yearly-tab" data-bs-toggle="tab"
                  data-bs-target="#yearly" role="tab" aria-controls="yearly"
                  @click="setActiveTab('yearly')"
                  aria-selected="false">Yearly
              </button>
            </li>
          </ul>
        </div>

        <div class="tab-content mt-40" id="myTabPricingContent">
          <div
              class="tab-pane"
              :class="{ show: activeTab === 'monthly', 'active': activeTab === 'monthly' }"
              id="monthly"
              role="tabpanel"
              aria-labelledby="monthly-tab"
          >
            <div class="row mt-2">
              <!-- Single Package Loop -->
              <div
                  v-for="pkg in monthlyPackages"
                  :key="pkg.id"
                  class="col-lg-4 col-md-6 mb-30"
              >
                <div
                    :class="['pricing-item rounded-lg m-auto mb-30', (activeTab === 'monthly' && pkg.id === active_sub.subscription_package_id) ? 'active' : '']">
                  <div class="pricing-header">
                    <h4>{{ pkg.name }}</h4>
                    <h2>AED {{ pkg.price }}</h2>
                    <div v-if="pkg.id === active_sub.subscription_package_id" class="badge">Current</div>
                  </div>
                  <div class="pricing-content pb-0">
                    <ul>
                      <li
                          v-for="(module, idx) in default_modules"
                          :key="module.id"
                          :class="['capitalize', !pkg.modules.includes(module.id) ? 'line-through' : '']"
                      >
                        {{ module.label }}
                        <span v-if="module.id === 'employee' && pkg.modules.includes(module.id)">
                        (Limit: {{ pkg.user_limit }})
                      </span>
                        <span v-if="module.id === 'location' && pkg.modules.includes(module.id)">
                        (Limit: {{ pkg.location_limit }})
                      </span>
                      </li>
                    </ul>
                  </div>
                  <div class="pricing-btn my-4">
                    <button
                        type="button"
                        :class="['button-1', pkg.id === active_sub.subscription_package_id ? 'disabled' : '']"
                        @click="openNewModel(pkg)"
                    >
<!--                        @click="switchPackage(pkg)"-->
                      Switch Package
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
              class="tab-pane fade"
              :class="{ show: activeTab === 'yearly', 'active': activeTab === 'yearly' }"
              id="yearly"
              role="tabpanel"
              aria-labelledby="yearly-tab"
          >
            <div class="row mt-2">
              <!-- Single Package Loop -->
              <div
                  v-for="pkg in yearlyPackages"
                  :key="pkg.id"
                  class="col-lg-4 col-md-6 mb-30"
              >
                <div
                    :class="['pricing-item rounded-lg m-auto', pkg.id === active_sub.subscription_package_id ? 'active' : '']">
                  <div class="pricing-header">
                    <h4>{{ pkg.name }}</h4>
                    <h2>AED {{ pkg.price }}</h2>
                    <div v-if="pkg.id === active_sub.subscription_package_id" class="badge">Current</div>
                  </div>
                  <div class="pricing-content pb-0">
                    <ul>
                      <li
                          v-for="(module, idx) in default_modules"
                          :key="module.id"
                          :class="['capitalize', !pkg.modules.includes(module.id) ? 'line-through' : '']"
                      >
                        {{ module.label }}
                        <span v-if="module.id === 'employee' && pkg.modules.includes(module.id)">
                        (Limit: {{ pkg.user_limit }})
                      </span>
                        <span v-if="module.id === 'location' && pkg.modules.includes(module.id)">
                        (Limit: {{ pkg.location_limit }})
                      </span>
                      </li>
                    </ul>
                  </div>
                  <div class="pricing-btn my-4">
                    <button
                        type="button"
                        :class="['button-1', pkg.id === active_sub.subscription_package_id ? 'disabled' : '']"
                        @click="openNewModel(pkg)"
                    >
<!--                        @click="switchPackage(pkg)"-->
                      Switch Package
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <package-create-edit-modal
        v-if="isLocationCreateOpenModalActive || isModalActive"
        v-model="isModalActive"
        :selected-url="selectedUrl"
        @close="isModalActive = false"
    />

<!--    Renew subscription model-->
<!--        v-if="renewSubscriptionModelEnabled"-->
    <renew-subscription-modal
        ref="renewModal"
        v-model="renewSubscriptionModelEnabled"
        v-if="renewSubscriptionModelEnabled"
        :package="selectedPackage"
        :extend-package="extendPackage"
        @switch-package="switchPackage"
        @close="renewSubscriptionModelEnabled = false"
    />
    <!--        :selected-url="selectedUrl"-->

    <new-subscription-modal
        ref="newModal"
        v-model="newSubscriptionModelEnabled"
        v-if="newSubscriptionModelEnabled"
        :selected-url="selectedUrl"
        :package="selectedPackage"
        @switch-package="switchPackage"
        @close="newSubscriptionModelEnabled = false"
    />

    <app-confirmation-modal
        v-if="confirmationModalActive"
        icon="trash-2"
        modal-id="app-confirmation-modal"
        @confirmed="confirmed('package-management-table')"
        @cancelled="cancelled"
    />

  </div>
</template>

<script>
import PackageCreateEditModal from "./PackageCreateEditModal";
import {
  GET_TENANT_PACKAGES,
  GET_ALL_PACKAGES,
  GET_TENANT_ACTIVE_SUBSCRIPTION,
  EXTEND_PACKAGE
} from "../../../Config/ApiUrl";
import PackageManagementMixin from "../../Mixins/PackageManagementMixin";
import {axiosGet, axiosPatch, axiosPost} from "../../../../common/Helper/AxiosHelper";
import SwitchInput from "../../../../core/components/input/SwitchInput";
import RenewSubscriptionModal from "./RenewSubscriptionModal";
import NewSubscriptionModal from "./NewSubscriptionModal";

const {TENANTS} = require("../../../Config/ApiUrl");

export default {
  components: {PackageCreateEditModal, SwitchInput, RenewSubscriptionModal, NewSubscriptionModal},
  mixins: [PackageManagementMixin],
  props: [
    'tenant_id'
  ],
  data() {
    this.fetchPackages();
    return {
      isModalActive: false,
      selectedUrl: '',
      extendPackage: '',
      EXTEND_PACKAGE,
      isLocationCreateOpenModalActive: false,
      subscriptionPackage: [],
      monthlyPackages: [],
      TENANTS,
      tenant_id: '',
      yearlyPackages: [],
      activeTab: 'monthly',
      active_sub: null,
      selectedPackage: null,
      newExpirationDate: '',
      renewSubscriptionModelEnabled: false,
      newSubscriptionModelEnabled: false,
      default_modules: [
        {'label': 'Employee', 'id': 'employee'},
        {'label': 'Location', 'id': 'location'},
        {'label': 'Attendance Management', 'id': 'attendance'},
        {'label': 'Leave Management', 'id': 'leave'},
        {'label': 'Asset Management', 'id': 'assets'},
        // {'label': 'Job Desk', 'id': 'job_desk'},
        // {'label': 'Administration', 'id': 'administration'},
      ],
    }
  },
  methods: {
    setActiveTab(tab) {
      this.activeTab = tab; // Update active tab
    },
    switchPackage(_package) {
      console.log("opening model with package", _package);
      this.selectedPackage = _package;


      let url = `${TENANTS}/${this.tenant_id}switch-package`;

      // axiosPatch(`${TENANTS}/${this.tenant_id}/switch-package`, { ..._package/*, new_expiration_date: this.newExpirationDate*/ })
      axiosPost(`${TENANTS}/${this.tenant_id}/renew-package`, { ..._package/*, new_expiration_date: this.newExpirationDate*/ })
          .then(({ data }) => {
            this.confirmationModalActive = false;
            this.toastAndReload(data.message, 'package-management-table');
            this.fetchPackages();
          })
          .catch((error) => {
            // Check if the error response exists and has a message
            if (error.response && error.response.data) {
              const errorMessage = error.response.data.message || 'An error occurred. Please try again.';
              this.toastAndReload(errorMessage, 'package-management-table');
            } else {
              // Handle unexpected errors
              this.toastAndReload('An unexpected error occurred. Please try again.', 'package-management-table');
            }
            this.confirmationModalActive = false;
          })
          .finally(() => {
          });
    },
    openModal() {
      this.isModalActive = true;
      this.selectedUrl = ''
    },
    openNewModel(_package) {
      this.selectedPackage = _package;
      this.newSubscriptionModelEnabled = true;
    },
    openRenewModel(_package) {
      this.selectedPackage = _package;
      this.renewSubscriptionModelEnabled = true;
    },
    fetchPackages() {
      axiosGet(GET_ALL_PACKAGES)
          .then(response => {
            this.monthlyPackages = response.data.data.filter((d) => d.billing_cycle === 'monthly');
            this.yearlyPackages = response.data.data.filter((d) => d.billing_cycle === 'yearly');
          });
      axiosGet(GET_TENANT_PACKAGES)
          .then(response => {
            this.tenant_id = response.data.data[0].tenant_id;
          });
      axiosGet(GET_TENANT_ACTIVE_SUBSCRIPTION)
          .then(response => {
            this.active_sub = response.data;
            console.log(this.active_sub);
          });
    },

    triggerActions(row, action, active) {
      this.subscriptionPackage = row;
      if (action.title === this.$t('edit')) {
        this.selectedUrl = `${GET_TENANT_PACKAGES}/${row.id}`;
        this.isModalActive = true;
      } else if (action.key === 'download') {
        this.exportInvoice(row.id);
      } else if (action.key === 'renew') {
        this.extendPackage = `${this.EXTEND_PACKAGE}/${this.tenant_id}/renew-package`;
        console.log(this.selectedUrl, this.extendPackage);
        this.openRenewModel();
      } else {
        this.getAction(row, action, active)
      }

    },
  },
}
</script>

<style>
.pricing-table-tab p {
  color: #0B2B3C;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
}

.pricing-table-tab ul {
  border-bottom: none;
  display: inline-block;
}

.pricing-table-tab ul .nav-item {
  display: inline-block;
}

.pricing-table-tab ul li button {
  text-transform: capitalize;
  padding: 5px 50px;
  position: relative;
  color: #949494;
  background: transparent;
  border: none;
  font-size: 18px;
  width: auto;
  border: none !important;
}

.pricing-table-tab ul li:first-child button {
  padding-left: 0 !important;
  padding-right: 35px;
}

.pricing-table-tab ul li:nth-child(2) button {
  padding-right: 0px;
}

.pricing-table-tab ul li button::before {
  position: absolute;
  content: "";
  width: 60px;
  height: 25px;
  background: #fff;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
  right: -43px;
  top: 67%;
  margin-top: -20px;
  border: 1px solid #00ACD4 !important;
  z-index: 1;
}

.pricing-table-tab ul li button::after {
  position: absolute;
  content: "";
  width: 16px;
  height: 14px;
  background: #00ACD4;
  -webkit-border-radius: 15px;
  -moz-border-radius: 15px;
  border-radius: 15px;
  margin-top: -15px;
  z-index: 1;
  top: 69%;
  right: -32px;
  -webkit-transition: all ease .3s;
  -moz-transition: all ease .3s;
  transition: all ease .3s;
  animation-name: fadeInLeft;
  -webkit-animation-name: fadeInLeft;
  -moz-animation-name: fadeInLeft;
  animation-duration: .3s;
  -webkit-animation-duration: .3s;
  -moz-animation-duration: .3s;
}

.pricing-table-tab ul li:nth-child(even) button {
  text-align: right
}

.pricing-table-tab ul li:nth-child(even) button::before {
  left: -27px;
  right: auto
}

.pricing-table-tab ul li:nth-child(even) button::after {
  right: auto;
  left: -22px;
  animation-name: fadeInRight;
  -webkit-animation-name: fadeInRight;
  -moz-animation-name: fadeInRight;
  animation-duration: .3s;
  -webkit-animation-duration: .3s;
  -moz-animation-duration: .3s
}

.pricing-table-tab ul li button.active::after, .pricing-table-tab ul li button.active::before {
  display: none;
  z-index: -9
}

.pricing-table-tab ul li button.active {
  color: #00acd4 !important;
}

.pricing-item {
  background: var(--navbar-bg);
  text-align: center;
  /*border: 2px solid rgba(239, 239, 239, 0.93);*/
  border-color: inherit;
  border: 1px solid;
  -webkit-transition: all .4s ease-in-out;
  transition: all .4s ease-in-out;
  max-width: 400px;
}

.pricing-btn button {
  background-image: linear-gradient(310deg, #00ACD4, #4ec6e2);
  padding: 10px 20px;
  border-radius: 50px;
  border: none;
}

/*.pricing-item:hover {
  transform: translateY(-10px);
  border-color: transparent;
  box-shadow: 0px 8px 17px 0px #eee;
}*/

.pricing-header {
  position: relative;
  padding: 30px 0px 50px 0px;
  z-index: 1;
  overflow: hidden;
}

.pricing-header::after {
  border-radius: 0 0 50% 50%;
  content: "";
  background-image: linear-gradient(310deg, #00ACD4, #4ec6e2);
  height: 100%;
  left: 0px;
  margin: 0 auto;
  opacity: .05;
  position: absolute;
  right: 0px;
  top: 0px;
  width: auto;
  z-index: -1;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

.pricing-item:hover .pricing-header::after {
  opacity: 1;
}

.pricing-item.active .pricing-header::after {
  opacity: 1;
}

.pricing-header h4 {
  font-size: 18px;
  text-transform: uppercase;
  margin-bottom: 10px;
  line-height: 1.2;
  font-weight: 600;
  color: #00ACD4;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

.pricing-item.active .pricing-header h4 {
  color: #fff;
}

.pricing-item:hover .pricing-header h4 {
  color: #fff;
}

.pricing-header h2 {
  font-size: 40px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

.pricing-item:hover .pricing-header h2 {
  color: #fff;
}

.pricing-item.active .pricing-header h2 {
  color: #fff;
}

.pricing-header .badge {
  position: absolute;
  top: 20px;
  right: -37px;
  background: #0d0044;
  border-radius: 0px;
  text-transform: uppercase;
  font-size: 12px;
  padding: 8px 40px;
  transform: rotate(50deg);
}

.pricing-content {
  padding: 30px 0;
}

.pricing-content ul {
  padding: 0;
}

.pricing-content ul li {
  line-height: 30px;
  font-size: 15px;
  font-weight: 400;
  border-bottom: 1px dashed #eee;
  padding: 9px 0;
  list-style: none;
}

.pricing-content ul li:last-child {
  border-bottom: none;
}

.pricing-item .pricng-btn {
  margin-bottom: 40px;
}

/*Random*/
/*.tab-pane.fade.show {*/
/*  transform: translateY(0rem);*/
/*}*/

.tab-pane.fade {
  transition: all 0.6s ease-out;
  /*transform: translateY(1rem);*/
}

.turn_ideas_section {
  background: #eee;
  border-radius: 10px;
  padding: 50px 30px;
}

.trun_ideas_contetn {
  text-align: center;
}

.trun_ideas_contetn img {
  width: 90%;
  margin: 0 auto;
  text-align: center;
}

.trun_ideas_nav .nav-item {
  width: 100%;
  display: block;
}

.trun_ideas_nav ul {
  border: none;
}

.nav-item button {
  width: 100%;
  text-align: left;
  border: none !important;
  position: relative;
  color: #67748e !important;
  font-weight: 600;
  text-transform: capitalize;
  font-size: 15px;
  padding: 25px 20px;
  border-radius: 5px;
  background: transparent !important;
}

.nav-item button:focus {
  outline: none;
}

.trun_ideas_nav .nav-item button i {
  font-size: 23px;
  padding-right: 7px;
  display: inline-block;
  float: left;
}

.trun_ideas_nav .nav-item button.active i {
  color: #00acd4;
}

.trun_ideas_nav .nav-item button::after {
  content: "";
  clear: both;
  display: block;
  position: absolute;
  width: 8px;
  height: 100%;
  top: 0;
  left: 0;
  background-image: linear-gradient(310deg, #00ACD4, #4ec6e2);
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  -webkit-transition: all .4s ease-in-out;
  transition: all .4s ease-in-out;
  visibility: hidden;
  opacity: 0;
}

.trun_ideas_nav .nav-item button.active::after {
  visibility: visible;
  opacity: 1;
}

.trun_ideas_nav .nav-item button.active {
  color: #00acd4 !important;
}

.mb-30 {
  margin-bottom: 30px;
}

.line-through {
  text-decoration: line-through;
}

.mt-30 {
  margin-top: 5rem;
}

/*Random*/
</style>